import { createSelector } from "reselect";

import { getEmails } from "../root";
import { selectSaleTitleWithCodeAndDateByIdLookup } from "../sales";

// The shape of a row in the top-level Email table.
export interface EmailAggridRow {
  email: Email;
  id: string;
  livestockSale: {
    title?: string;
  };
}

export const selectEmailAggridData = createSelector(
  [getEmails, selectSaleTitleWithCodeAndDateByIdLookup],
  (emails, saleTitleWithCodeAndDateByIdLookup) =>
    Object.values(emails).map(
      (email: Email): EmailAggridRow => ({
        email,
        id: email.id,
        livestockSale: {
          title: saleTitleWithCodeAndDateByIdLookup[email.livestockSaleId],
        },
      }),
    ),
);
